import { useCallback, useEffect, useRef, useState } from "react"

export function useIsSticky() {
  const ref = useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = useState(false)

  const checkIsSticky = useCallback(() => {
    const element = ref.current

    if (!element) return

    const computedStyle = window.getComputedStyle(element)
    const stickyTop = Number.parseInt(computedStyle.top)
    const elementTop = element.getBoundingClientRect().top

    setIsSticky(elementTop <= stickyTop)
  }, [])

  useEffect(() => {
    checkIsSticky()

    window.addEventListener("scroll", checkIsSticky)

    return () => window.removeEventListener("scroll", checkIsSticky)
  }, [checkIsSticky])

  return { ref, isSticky }
}
